import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLanding = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Layer_1",
	viewBox: "466.31 462.56 987.41 154.86",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #15192d;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M540.92,587.93h-41.35v-96.11c0-17.22,4.34-24.47,4.34-24.47v-1.6h-37.6v1.6s4.34,7.25,4.34,24.47v96.34c0,17.22-4.34,24.47-4.34,24.47v1.6h90.96l9.73-30.64h-1.6s-7.25,4.34-24.47,4.34"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M638.32,554.2l19.73-57.06,19.94,57.06h-39.67ZM717.04,574.8l-42.66-109.06h-32.03l-42.54,109.06c-11.73,29.79-19.97,37.84-19.97,37.84v1.6h43.35c0-7.91.37-17.29,3.79-27.41h0s1.79-5.26,1.79-5.26h58.55l1.86,5.26c3.42,10.11,3.94,19.49,3.94,27.41h43.9v-1.6s-8.24-8.04-19.97-37.84h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M982.35,586.88h-23.34v-93.77h23.34c23.76,0,45.19,15.27,45.19,46.88s-21.43,46.88-45.19,46.88M983.62,465.74h-59.92v1.62s4.34,7.25,4.34,24.47v96.34c0,17.22-4.34,24.47-4.34,24.47v1.6h59.92c42,0,76.16-26.31,76.16-74.25s-34.15-74.25-76.16-74.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M1084.8,465.75v1.6s4.34,7.25,4.34,24.47v96.34c0,17.22-4.34,24.47-4.34,24.47v1.6h37.6v-1.6s-4.34-7.25-4.34-24.47v-96.34c0-17.22,4.34-24.47,4.34-24.47v-1.6h-37.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M858.93,465.76v1.6s4.34,7.25,4.34,24.47v54.95c-7.45-9.68-18.99-18.3-31.08-27.31-19.72-14.7-40.1-29.89-42.36-50.31v-3.41h-33.27v1.6s4.34,7.25,4.34,24.47v96.34c0,17.22-4.34,24.47-4.34,24.47v1.6h37.6v-1.6s-4.34-7.25-4.34-24.47v-68.96c7.19,8.83,16.74,15.73,26.74,22.95,21.29,15.36,43.29,31.23,46.69,68.68v3.41h28.93v-122.41c0-17.22,4.34-24.47,4.34-24.47v-1.6h-37.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M1251.77,465.76v1.6s4.34,7.25,4.34,24.47v54.95c-7.45-9.68-18.99-18.3-31.08-27.31-19.72-14.7-40.1-29.89-42.36-50.31v-3.41h-33.27v1.6s4.34,7.25,4.34,24.47v96.34c0,17.22-4.34,24.47-4.34,24.47v1.6h37.6v-1.6s-4.34-7.25-4.34-24.47v-68.96c7.19,8.83,16.74,15.73,26.74,22.95,21.29,15.36,43.29,31.23,46.69,68.68v3.41h28.93v-122.41c0-17.22,4.34-24.47,4.34-24.47v-1.6h-37.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M1414.06,532.15v1.6s4.34,7.25,4.34,24.47v22.51c-6.58,5.31-16.54,8.06-28.85,8.06-27.79,0-44.76-18.46-44.76-48.16,0-32.03,19.09-49.64,50.28-49.64,14.67,0,27.14,3.41,36.94,8.85l14.43-27.81-1.41-.75s-4.53.42-18.18-3.74l.1.05c-9.16-3.14-19.73-5.03-32.3-5.03-50.49,0-82.31,31.18-82.31,77.85s29.7,77.01,76.37,77.01c26.31,0,47.94-9.33,60.67-23.34v-35.87c0-17.22,4.34-24.47,4.34-24.47v-1.6h-39.65Z"
		})
	]
});
const ForwardRef = forwardRef(SvgLanding);
export { ForwardRef as ReactComponent };
